<script>
  // core components
  import ActivoView from "../../viewsERP/Activo.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <ActivoView />
  </div>
</div>
